<template>
  <v-dialog v-model="dialog" persistent width="750">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>done</v-icon>Validar programación
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <h4>
                  <strong>Nombre:</strong> {{ this.form.servidor_publico }}
                </h4>
              </v-flex>
              <v-flex xs12>
                <h4><strong>Detalle papeleta</strong></h4>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  :items="lista_programaciones"
                  class="elevation-1"
                  hide-actions
                  :headers="headers"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.fecha_desde }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_hasta }}</td>

                    <td class="text-xs-center">{{ props.item.total_dias }}</td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <!-- <v-flex xs12>
              <h4><strong>Seguimiento papeleta</strong></h4>
            </v-flex>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  :items="lista_detalle"
                  class="elevation-1"
                  hide-actions
                  :headers="headers2"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      {{ props.item.fecha_registro }}
                    </td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                    <td class="text-xs-center">{{ props.item.usuario }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout> -->
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.prevent="close()" :loading="loading"
            ><v-icon>close</v-icon>
            Cancelar
          </v-btn>

          <v-btn color="primary" @click.prevent="validarProgramacion()"
            ><v-icon>done</v-icon>
            Validar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,

      form: {},
      //url: 'vCronoVacass',
      valid: false,
      loading: false,
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      fecha_desde: "",
      fecha_hasta: "",
      gestion: "",
      persona: null,
      gestion_f:this.$route.params.gestion,
      saldo: null,
      periodo: null,
      id_estado_programacion: null,
      id: null,
      lista_programaciones: [],
      lista_detalle: [],
      headers: [
        { text: "Fecha salida", sortable: false, align: "center" },
        { text: "Fecha fin", sortable: false, align: "center" },

        { text: "Dias", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" }
      ],
      headers2: [
        { text: "Fecha registro", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
        { text: "Usuario", sortable: false, align: "center" }
      ]
    };
  },
  mounted() {
    this.$bus.$on("openDialogValidarProgramacionJefeInmediatoPorFuncionario", async item => {
      this.form = item;
      await this.cargarDetalleProgramacion();
      await this.verEstadoVacacion();
      this.dialog = true;
    });
  },

  methods: {
    close() {
      this.form = {};
      this.lista_programaciones = [];
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogValidarProgramacionJefeInmediatoPorFuncionario");
      this.dialog = false;
      
    },
    // Metodo para cargar el detalle de las programaciones
    async cargarDetalleProgramacion() {
      try {
        let res = await this.$service.graphql({
          query: `
		  query{
			vVacaProgramadas(id_persona:${parseInt(this.form.id_persona)},gestion:"${(this.gestion_f)}"){
				rows{
				id
				fecha_desde
				fecha_hasta
				id_estado
				fecha_solicitud
				id_persona
				total_dias
				estado
				}
			}
			}
          `
        });
         let lista=[]
         res.vVacaProgramadas.rows.forEach(element => {
          if (element.id_estado!=47 && element.id_estado!=9) {
            lista.push(element)
          }
      
        });
            this.lista_programaciones = lista
      } catch (error) {
        console.log(error);
      }
    },
    async cargarSeguimiento() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
			query{
				runQuery(consulta:"select * from vacaciones.v_seguimiento_vaca_progra vsvp  where vsvp.id_vaca_progra =${this.form.id}"){
					respuesta
				}
				}
			`
        });
        respuesta = respuesta.runQuery.respuesta;
        this.lista_detalle = respuesta;
      } catch (error) {
        console.log(error);
      }
    },
    async verEstadoVacacion() {
      let user = this.$storage.get("user");
      let id_persona = user.id_persona;
      let gestion = this.$route.params.gestion;
      try {
        let res = await this.$service.graphql({
          query: `
						query{
              vEstadoVacacions(id_persona: ${this.form.id_persona},gestion_hasta:"${gestion}"){
                rows{
                  nombre
                  dias_saldo
                  dias_asignados
                  dias_utilizados
                  dias_programados
                  dias_cta_vacacion
                  id
                  id_estado
                  id_persona
                  nombre
                  ingreso
                  gestion_desde
                  gestion_hasta
                  cas
                  estado
                  dias_a_programar
                  total_dias_saldo
                  saldo_a_programar
                  id_programacion
                  id_estado_programacion
                  estado_programacion
                }
              }
            } 
					`
        });
        let estado_vacacion = res.vEstadoVacacions.rows;
        this.id_estado_programacion = parseInt(estado_vacacion[0].id);
      } catch (error) {
        console.log(error);
      }
    },
    async validarProgramacion() {
      let respuesta;
      let resps = [];
      let correcto = true;
      let user = this.$storage.get("user");
      this.form.motivo = "0 motivo";
      this.loading = true;
      try {
        console.log(`
            query{
              runQuery(consulta:"select vacaciones.fn_valida_vacacion_programada_por_persona(${parseInt(this.$route.params.gestion)},${this.form.id_persona},73,${user.id})"){
                respuesta
              }
            }
          `)
        respuesta = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta:"select vacaciones.fn_valida_vacacion_programada_por_persona(${parseInt(this.$route.params.gestion)},${this.form.id_persona},73,${user.id})"){
                respuesta
              }
            }
          `
        });
        respuesta =
          respuesta.runQuery.respuesta[0]
            .fn_valida_vacacion_programada_por_persona;
        resps = respuesta.split("|");
        correcto = resps[0];
        if (correcto === "1") {
          this.$alert("La solicitud fue validada", () => {
            document.location.reload()
            this.loading = false;
            this.close();
          });
        } else {
          this.$alert(resps[1], () => {
            this.loading = false;
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacaciones/dialogs/ValidarProgramacionJefeInmediatoPorFuncionario.vue